
import React, { useEffect, useRef, useState } from "react";
import "./MyHomePage.css";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
function MyHomePage() {
  const [isFixed, setIsFixed] = useState(false);
  const [isFixed2, setIsFixed2] = useState(false);
  const [isFixed3, setIsFixed3] = useState(false);
  const [translateX, setTranslateX] = useState(0);
  const [translateX2, setTranslateX2] = useState(0);
  const [translateX3, setTranslateX3] = useState(0);
  const [translateX4, setTranslateX4] = useState(0);
  const [translateX5, setTranslateX5] = useState(0);
  const [translateX6, setTranslateX6] = useState(0);
  const [translateX7, setTranslateX7] = useState(0);
  const [translateX8, setTranslateX8] = useState(0);
  const [translateX9, setTranslateX9] = useState(0);
  const targetRef = useRef(null); 
   const targetRef2 = useRef(null);
  const targetRef3 = useRef(null);
  const scrollThreshold = 100; // Distance to move the div horizontally
  const [startScroll, setStartScroll] = useState(0);

 const dispatch = useDispatch();
  
    useEffect(()=>{
      dispatch({
        type: "pageTitle",
        
        payload:"Home : MyApp"
      });
      dispatch({
        type: "pageDescription",
        
        payload:"This is a dynamic description."
      });dispatch({
        type: "pageSEO",
        
        payload:"seo, react, meta"
      });
    },[])
  useEffect(() => {
    const handleScroll = () => {
      if (targetRef.current) {
        // const elementTop = targetRef.current.getBoundingClientRect().top;
        const elementTop = targetRef.current.getBoundingClientRect().top-230;
        const scrollHt=targetRef.current.scrollHeight;
        // Check if the div has touched the top of the viewport
        if (elementTop <= 0 ) {
          setIsFixed(true);setStartScroll(elementTop);
          setTranslateX(0); // Reset translateX when fixed
          setTranslateX(0); 
            setTranslateX2(0); 
            setTranslateX3(0);
            setTranslateX4(0);
            setTranslateX5(0);
            setTranslateX6(0);
            setTranslateX7(0);
            setTranslateX8(0);
            setTranslateX9(0);
        }

        // If fixed, move div horizontally with scroll and unfix after 500px
        if (isFixed) {
          // const scrolledDistance = window.scrollY - targetRef.current.offsetTop;
          const scrolledDistance = Math.abs(window.scrollY - elementTop);
       
          if (scrolledDistance>3*scrollHt+400) {
            setTranslateX(scrolledDistance-3*scrollHt-400);
            setTranslateX2(scrolledDistance-3*scrollHt-600); 
            setTranslateX3(scrolledDistance-3*scrollHt-800); 
            setTranslateX4(scrolledDistance-3*scrollHt-1000); 
            setTranslateX5(scrolledDistance-3*scrollHt-1200); 
            setTranslateX6(scrolledDistance-3*scrollHt-1600); 
            
            setTranslateX7(scrolledDistance-3*scrollHt-1800); 
            setTranslateX8(scrolledDistance-3*scrollHt-1700); 
            setTranslateX9(scrolledDistance-3*scrollHt-1900); 
            // Move the div horizontally
          } else {
            setIsFixed(false); // Unfix after scrolling beyond the threshold
            setTranslateX(0); 
            setTranslateX2(0); 
            setTranslateX3(0); // Reset position when unfixing
            setTranslateX4(0); // Reset position when unfixing
            setTranslateX5(0); // Reset position when unfixing
            setTranslateX6(0); // Reset position when unfixing
            setTranslateX7(0); // Reset position when unfixing
            setTranslateX8(0); // Reset position when unfixing
        setTranslateX9(0); // Reset position when unfixing
        }
        }
      }
     
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup on component unmount
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isFixed]);

  return (
    <div style={{}}  >  
{/* <div style={{position:"fixed",bottom:"10px",right:"10px"}}>
    ----  X1: {translateX}  , SS:{startScroll}  --- ---  X2: {translateX2}  ,  -----    X3: {translateX3} </div>  */}
    <div style={{ height: "100vh" ,}} > </div> 
    <div style={{ height: "100vh" ,}} > </div> 
    <div style={{ height: "100vh" ,}} > </div> 
    
    <div  class="scrollContainerHeight">
      <div 
        ref={targetRef}
        className={`${translateX?"fixed-div":"normal-div-first"}  `}
        style={{ left: `${translateX>300?-translateX/2:0}%`,width: "100vh" , }} // Move the div horizontally
      >
      X1: {translateX}  This div becomes fixed when it touches the top and moves right when scrolled
      </div>
      
      <div 
        
        className={`${translateX>100?"fixed-div":"normal-div"}  `}
        style={{ left: `${translateX2/2-48}%`,}} // Move the div horizontally
      >
      X2: {translateX2}  This div becomes fixed when it touches the top and moves right when scrolled
      </div>
        <div 
 
 className={`${translateX>310?"fixed-div":"normal-div"}  `}
 style={{ left: `${translateX3/2-54}%`, }} // Move the div horizontally
>
X3: {translateX3}  This div becomes fixed when it touches the top and moves right when scrolled
</div>
<div 
 
  className={`${translateX>420?"fixed-div":"normal-div"}  `}
  style={{ left: `${-translateX4/2+54}%`, }} // Move the div horizontally
>
X4: {translateX4}  This div becomes fixed when it touches the top and moves right when scrolled
</div>
<div 
 
  className={`${translateX>530?"fixed-div":"normal-div"}  `}
  style={{ left: `${-translateX5/2+60}%`, }} // Move the div horizontally
>
X5: {translateX5}  This div becomes fixed when it touches the top and moves right when scrolled
</div><div 
 
 className={`${translateX>640?"fixed-div":"normal-div"}  `}
 style={{ left: `${translateX6/2+66}%`, }} // Move the div horizontally
>
X6: {translateX6}  This div becomes fixed when it touches the top and moves right when scrolled
</div>

<div 
 
  className={`${translateX>750?"fixed-div":"normal-div"}  `}
  style={{ left: `${translateX7>140&&translateX7<240?0:translateX7/2+60}%`, }} // Move the div horizontally
>
X7: {translateX7}  This div becomes fixed when it touches the top and moves right when scrolled X7
</div>



<div 
 
  className={`${translateX>860?"fixed-div":"normal-div"}  `}
  style={{ left: `${translateX8>140&&translateX8<400?0:-translateX8/2+82}%`, }} // Move the div horizontally
>
X8: {translateX8}  This div becomes fixed when it touches the top and moves right when scrolled
</div>

<div 
 
  className={`${translateX>970&&translateX9<240?"fixed-div":"normal-div-last"}  `}
  style={{ left: `${translateX9>140&&translateX9<240?0:-translateX9/2+72}%`, }} // Move the div horizontally
>
X9: {translateX9}  This div becomes fixed when it touches the top and moves right when scrolled
</div>
</div>
 <div style={{ height: "10vh" ,}} > </div> 
{/* <div style={{ height: "100vh" ,}} > </div> 
    <div style={{ height: "100vh" ,}} > </div> 
    <div style={{ height: "20vh" }} > </div>   */}

    <div style={{ height: "200vh" 
    ,background:"#f1f1f1"
    

    }} > </div> 
     <div style={{ height: "100vh" 
    ,background:"#e1e1e1"
   

    }} > </div>
    </div>
  );
}

export default MyHomePage;
